"use strict";
module.exports = {
    background: '#f4f4f4',
    primaryColor: '#822ed8',
    fontColor: 'rgb(49, 70, 89)',
    borderColor: 'rgba(0,0,0, 0.2)',
    dateFormat: 'DD-MM-YYYY',
    colors: ['#B12AB8', '#0DD9A4', '#056950', '#8E5EA2', '#E8C3B9', '#3E95CD', '#0DD9A4', '#056950', '#8E5EA2', '#E8C3B9']
};
